  import React, { useEffect, useState } from "react";
 import { Button, Input, Select, Table } from "antd";
 import "aos/dist/aos.css";
 import "../../MainCSS.css";
 import { Option } from "antd/es/mentions";
 import axios from "axios";
 import { toast } from "react-toastify";
 import { GetConsigneeMaster, GetCustomerMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
 import { SaveConsigneeMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
 import { UpdateConsigneeMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
 import { DeleteConsigneeMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
 
 const ConsigneeMaster = () => {
 
  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {};
  // const storedUserData = sessionStorage.getItem('userData') || '';

 const commonHeaders = {
  headers: {
    // createdBy: storedUserData || '',
    // updatedBy: storedUserData || '',
    createdBy: 1,
    updatedBy: 2,
    userIp: storedHeaders.userIp || '',
    userLat: storedHeaders.userLat || '',
    userLong: storedHeaders.userLong || '',
    deviceSign: storedHeaders.deviceSign || '',
  },
};

const commonHeaders1 = {
  headers: {
    createdBy: 1,
    updatedBy: 2,
  },
}
 
   const [errors, setErrors] = useState({
     customerName: "",
     consigneeName: "",
     address: "",
     city: "",
     pinCode: "",
     gstIn: "",
   });
 
 
   const [pageSize, setPageSize] = useState(10);
   const [filteredData, setFilteredData] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [totalEntries, setTotalEntries] = useState(0);
 
   const [consigneeId, setConsigneeId] = useState("");
   const [consigneeName, setConsigneeName] = useState(""); 
   const [customerName, setCustomerName] = useState(""); 
   const [address, setAddress] = useState("");
   const [city, setCity] = useState("");
   const [pinCode, setPinCode] = useState("");
   const [gstIn, setGstIn] = useState("");
 
   const [allConsignee, setAllConsignee] = useState([]);
   const [allCustomer, setAllCustomer] = useState([]);
   const [updateButton, setUpdateButton] = useState(false);
   const [saveButton, setSaveButton] = useState(true);
 
 
   //======Search data from table===============
   const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allConsignee.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
   //==========Pagination=======================
   const handlePageSizeChange = (value) => {
     setPageSize(value);
   };
 
 
     // Fetch Customer, Consignee Names
     let isConsigneeFetched = false;
     useEffect(() => {
       if (isConsigneeFetched) return;
       fetchConsignee();
       fetchCustomer();
       isConsigneeFetched = true;
     }, []);
 
   // ==============Get Table Data================
 
   let isError = false;
 
   const fetchConsignee = async () => {
     try {
       const response = await axios.get(GetConsigneeMaster,commonHeaders1);
       if (response.data !== null) {
         setAllConsignee(response.data);
         setFilteredData(response.data); 
         setTotalEntries(response.data.length);
       }
     } catch (error) {
       if (!isError) {
         console.error("Error fetching Consignee:", error);
         toast.error("Failed to fetch Consignee data");
         isError = true; 
       }
     }
   };
 
  //  const columns = [
  //    {
  //      title: "Sr.No.",
  //      dataIndex: "",
  //      key: "index",
  //      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //    },
  //    {
  //      title: "Customer Name",
  //      dataIndex: "customerName",
  //      key: "customerName",
  //    },
  //    {
  //      title: "Consignee Name",
  //      dataIndex: "name",
  //      key: "name",
  //    },
  //    {
  //      title: "Address",
  //      dataIndex: "address",
  //      key: "address",
  //    },
  //    {
  //      title: "City",
  //      dataIndex: "city",
  //      key: "city",
  //    },
  //    {
  //      title: "Pin Code",
  //      dataIndex: "pinCode",
  //      key: "pinCode",
  //    },
  //    {
  //      title: "GSTIN",
  //      dataIndex: "gstin",
  //      key: "gstin",
  //    },
  //    {
  //      title: "Actions",
  //      key: "actions",
  //      render: (text, record) => (
  //        <div>
  //          <span
  //            type="submit"
  //            style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
  //            onClick={() => handleEditDataButton(record)}
  //          >
  //            <i class="fa-solid fa-pen-to-square"></i>
  //          </span>
  //          <span
  //            type="submit"
  //            style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
  //            onClick={() => handleDeleteData(record)} 
  //          >
  //            <i class="fa-solid fa-trash"></i>
  //          </span>
  //        </div>
  //      ),
  //    },
  //  ];
 

  const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    sorter: (a, b) => a.customerName?.localeCompare(b.customerName),
  },
  {
    title: "Consignee Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name?.localeCompare(b.name),
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    sorter: (a, b) => a.address?.localeCompare(b.address),
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    sorter: (a, b) => a.city?.localeCompare(b.city),
  },
  {
    title: "Pin Code",
    dataIndex: "pinCode",
    key: "pinCode",
    sorter: (a, b) => {
      const aVal = isNaN(a.pinCode) ? a.pinCode : parseInt(a.pinCode);
      const bVal = isNaN(b.pinCode) ? b.pinCode : parseInt(b.pinCode);
      return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    },
  },
  {
    title: "GSTIN",
    dataIndex: "gstin",
    key: "gstin",
    sorter: (a, b) => a.gstin?.localeCompare(b.gstin),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];

   const components = {
     header: {
       cell: ({ children, ...restProps }) => (
         <th
           {...restProps}
           style={{
             backgroundColor: "#023E7D",
             color: "#fff",
             padding: "10px",
             fontSize: "13px",
             borderRadius: "0px",
           }}
         >
           {children}
         </th>
       ),
     },
     body: {
       row: ({ children, ...restProps }) => (
         <tr
           {...restProps}
           style={{
             backgroundColor: "#f0f7fd",
           }}
         >
           {children}
         </tr>
       ),
       cell: ({ children, ...restProps }) => (
         <td
           {...restProps}
           style={{
             padding: "8px",
           }}
         >
           {children}
         </td>
       ),
     },
   };
 
   const fetchCustomer = async () => {
  
    try {
      const response = await axios.get(GetCustomerMaster,commonHeaders1);
      if (response.data !== null) {
        setAllCustomer(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customer:", error);
        toast.error("Failed to fetch Customer data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };
 
  //=========CANCEL CONSIGNEE DATA============
 const handleCancel = () => {
   setCustomerName("");
   setConsigneeName("");
   setAddress("");
   setCity("");
   setPinCode("");
   setGstIn("");
 
   setUpdateButton(false);
   setSaveButton(true);
   setErrors("");
 };
 
  //=========SAVE CONSIGNEE DATA============
     const handleSubmit = async () => {
         let isValid = true;
         const errorObj = {};  
     
         if (!customerName) {
           isValid = false;
           errorObj.customerName = "Customer Name is required *";
         }
         if (!consigneeName.trim()) {
           isValid = false;
           errorObj.consigneeName = "Consignee Name is required *";
         }
         if (!address) {
           isValid = false;
           errorObj.address = "Address is required *";
         }
         if (!city) {
           isValid = false;
           errorObj.city = "City is required *";
         }
         if (!pinCode) {
           isValid = false;
           errorObj.pinCode = "Pin Code is required *";
         }
         if (!gstIn) {
           isValid = false;
           errorObj.gstIn = "GSTIN is required *";
         }
        
     
         setErrors(errorObj); // Set error messages
     
         if (!isValid) return;
     
         const saveData = {
             customerId: customerName,
             name: consigneeName,
             address: address,
             city: city,
             pinCode: parseInt(pinCode),
             gstin: gstIn,
           };       
         
     
         try {
           const response = await axios.post(SaveConsigneeMaster, saveData,commonHeaders);
     
           if (response.data === "CREATED") {
             toast.success("Consignee added successfully!");
             fetchConsignee();
             handleCancel();
           }
           else if (response.data === "ALREADYEXISTED") {
             toast.warn("Consignee already exist!");
             handleCancel();
           }
         } catch (error) {
           console.error("Error during API call:", error);
           toast.error("Error occurred while submitting data");
         }
     };
 
 //=========EDIT CONSIGNEE DATA============
 const handleEditDataButton = (item) => {
   setUpdateButton(true);
   setSaveButton(false);
 
   setConsigneeId(item.id);
   setConsigneeName(item.name);
   setCustomerName(item.customerId);
   setAddress(item.address);
   setCity(item.city);
   setPinCode(item.pinCode);
   setGstIn(item.gstin);
 };
 
  //=========UPDATE CONSIGNEE DATA============
 const handleUpdate = async () => {
   if (
     !customerName || !consigneeName || !address ||  !city || !pinCode || !address || !gstIn ) {
     toast.warn("Please fill all fields!");
     return;
   }
 
   const updateData = {
     id: consigneeId,
     customerId: customerName,
     name: consigneeName,
     address: address,
     city: city,
     pinCode: parseInt(pinCode),
     gstin: gstIn,
   };
 
 
   try {
     const response = await axios.put(UpdateConsigneeMaster, updateData,commonHeaders);
 
     if (response.data === "UPDATED") {
       toast.success("Consignee updated successfully!");
       fetchConsignee();
       handleCancel();
     }
     else if (response.data === "ALREADYEXISTED") {
       toast.warn("Consignee already exist!");
       handleCancel();
     }
   } catch (error) {
     console.error("Error during API call:", error);
     toast.error("Error occurred while updating data");
   }
 };
 
  //=========DELETE CONSIGNEE DATA============
 const handleDeleteData = async (item) => {
   const confirmDelete = window.confirm(
     `Are you sure you want to delete the Consignee "${item.name}"?`
   );
   if (!confirmDelete) return;
 
   try {
     const response = await axios.delete(`${DeleteConsigneeMaster}?id=${item.id}`,commonHeaders1);
     if (response.data === "DELETED") {
       toast.success("Consignee deleted successfully!");
       fetchConsignee();
       handleCancel();
     }
   } catch (error) {
     console.error("Error during delete operation:", error);
     toast.error("Error occurred while deleting the Consignee");
   }
 };
 
   return (
     <>
        <div className="px-5 py-3">
          <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
              <div className="col-12">
          
                <div className="row px-md-5 mt-3 p-2" >
                    <div className="col-12 col-lg-2"></div>
                    <div className="col-12 col-lg-8">
                      <div className="row p-0 m-0">
          
                        <div className="col-10 py-1">
                              <label className="labels">Customer Name</label>
                                                <Select maxLength={250}
                                                  value={customerName || undefined}
                                                  onChange={setCustomerName}
                                                  showSearch
                                                  className="w-100"
                                                  placeholder="Select Customer"
                                                  optionFilterProp="children"
                                                >
                                                  {allCustomer.map((customer) => (
                                                    <Option key={customer.id} value={customer.id}>
                                                      {customer.customerName}
                                                    </Option>
                                                  ))}
                                                </Select>
                                                {errors.customerName && (
                                                  <div className="errorField">{errors.customerName}</div>
                                                )}
                        </div>

                        <div className="col-10 py-1">
                              <label className="labels">Consignee Name</label>
                              <Input
                                value={consigneeName} maxLength={250}
                                onChange={(e) => setConsigneeName(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.consigneeName && (
                                <div className="errorField">{errors.consigneeName}</div>
                              )}
                        </div>

                        <div className="col-lg-8 py-1">
                              <label className="labels">GSTIN</label>
                              <Input
                                value={gstIn} maxLength={250}
                                onChange={(e) => setGstIn(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.gstIn && (
                                <div className="errorField">{errors.gstIn}</div>
                              )}
                        </div>
          
                        <div className="col-lg-10 py-1">
                            <label className="labels">Address</label>
                            <Input.TextArea
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                              placeholder="Enter Address"
                              maxLength={250} 
                            />
                            {errors.address && <div className="errorField">{errors.address}</div>}
                        </div> 
          
                        <div className="col-lg-8 py-1">
                              <label className="labels">City</label>
                              <Input
                                value={city} maxLength={250}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.city && (
                                <div className="errorField">{errors.city}</div>
                              )}
                        </div>
          
                        <div className="col-lg-4 py-1">
                              <label className="labels">PinCode</label>
                              <Input
                                value={pinCode}
                                onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d{0,10}$/.test(value)) setPinCode(value); // only allow up to 10 digits
                                    }}
                                placeholder="Enter Code"
                              />
                              {errors.pinCode && (
                                <div className="errorField">{errors.pinCode}</div>
                              )}
                        </div>
          
                                                    
          
                      </div>  
                    </div>
                    <div className="col-12 col-lg-2"></div>
          
                        <div className="col-12 text-center pt-3">
                          <Button
                            type="submit"
                            className="CancelBtn mx-1"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          {saveButton && (
                          <Button
                            type="submit"
                            className="SubmitBtn mx-1"
                            onClick={handleSubmit}
                          >
                            Submit
                          </Button>
                          )}
                          {updateButton && (
                            <Button
                              type="submit"
                              className="UpdateBtn mx-1"
                              onClick={handleUpdate}
                            >
                              Update
                            </Button>
                          )}
                        </div>
          
                  <div  className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid rgb(207, 207, 207)" }}></div>
                </div>
          
                {/*================ Table =========================*/}
                <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
                  <div
                    className="col-12 py-3 shadow border"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="col-12 px-md-5"
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <div>
                        <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                        <Select
                          defaultValue={pageSize}
                          onChange={handlePageSizeChange}
                          style={{ width: 120, textAlign: "center" }}
                        >
                          <Option value={10}>10</Option>
                          <Option value={20}>20</Option>
                          <Option value={30}>30</Option>
                        </Select>
                      </div>
          
                      <div className="pt-4 pt-md-0">
                        <Input.Search
                          placeholder="Search"
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{ width: 200, marginBottom: 16 }}
                        />
                      </div>
                    </div>
          
                    <div style={{ backgroundColor: "white" }}>
                      <Table
                        bordered
                        style={{ padding: "0px 20px", overflowX: "auto" }}
                        columns={columns}
                        dataSource={filteredData}
                        pagination={{
                          pageSize: pageSize,
                          total: totalEntries,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          current: currentPage,
                          onChange: (page) => setCurrentPage(page),
                        }}
                        showSorterTooltip={false}
                        rowKey={(record) => record.id}
                        components={components}
                      />
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </>
   )
 }
 
 export default ConsigneeMaster
